import {
  fetchTrack,
  fetchTranscript,
} from '.';
import {
    playClip as playClipAction, playerSeek
} from '../actions';
import {
  IAlignedWord,
  IClip,
} from '../api';
import { ThunkAction } from '../types';

export function playClip(clip: IClip): ThunkAction {
  return async (dispatch, getState) => {      
    const {player} = getState();
    const recordingID = clip.recording_id || player.recordingId;

    await dispatch(playClipAction.request(clip));

    if (recordingID) {
      dispatch(fetchTrack(recordingID, {full: true}));
      dispatch(fetchTranscript(recordingID));
    }
  }
}

export function audioForward(): ThunkAction {
    return async (dispatch, getState) => {
      const {
        player,
        transcripts,
      } = getState();
      const {
        data,
        selected,
      } = transcripts;
      const {
        currentTime
      } = player;

      if (!selected) {
        return;
      }

      const alignment = data[selected] ? data[selected].alignment : null;

      let nextWord: IAlignedWord | undefined;
      if (alignment && currentTime !== null) {
        nextWord = alignment.find(w => w.start > currentTime);
      }

      if (nextWord) {
        dispatch(playerSeek({
          isPlaying: true,
          time: nextWord.start,
          timeRelative: false,
        }));
        return;
      }

      dispatch(playerSeek({
        isPlaying: true,
        time: 5,
        timeRelative: true,
      }));
    };
  }


export function audioBack(): ThunkAction {
  return async (dispatch, getState) => {
    const {
      player,
      transcripts,
    } = getState();
    const {
      data,
      selected,
    } = transcripts;
    const {
      currentTime
    } = player;

    if (!selected) {
      return;
    }
    
    const alignment = data[selected] ? data[selected].alignment : null;
    let prevWord: IAlignedWord | undefined;
    if (alignment && currentTime !== null) {
      prevWord = alignment
        .reverse()
        .find(w => w.start < currentTime);
    }

    if (prevWord) {
      dispatch(playerSeek({
        isPlaying: true,
        time: prevWord.start,
        timeRelative: false,
      }));
      return;
    }

    dispatch(playerSeek({
      isPlaying: true,
      time: -5,
      timeRelative: true,
    }));
  };
}
  


// WEBPACK FOOTER //
// ./src/thunks/playerThunks.ts